import { styled, TableCell, TableRow } from '@shared/components';

import { useItemAnalysisSearchParams } from '../../hooks';
import { type ItemAnalysisTableData } from '../../types';

export interface ItemAnalysisResponseStatisticsTableBodyProps {
  rows: ItemAnalysisTableData;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderColor: theme.palette.grey[300],
  borderRight: `1px solid ${theme.palette.grey[300]}`,
  ...theme.typography.body2Semibold,
}));

export default function ItemAnalysisResponseStatisticsTableBody(
  props: Readonly<ItemAnalysisResponseStatisticsTableBodyProps>,
) {
  const [{ pageSize, page }] = useItemAnalysisSearchParams();
  const { rows } = props;

  return (
    <>
      {rows.map((row, rowIndex) => {
        return (
          <TableRow key={row.questionRefCode} sx={{ border: 'none' }}>
            <StyledTableCell align='center' sx={{ minWidth: '64px' }}>
              {rowIndex + 1 + page * pageSize}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '200px' }}>
              {row.questionRefCode}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.answer}
            </StyledTableCell>
            <StyledTableCell align='center' sx={{ minWidth: '100px' }}>
              {row.numbersOfExaminees.reduce((sum, curr) => sum + (curr.total ?? 0), 0)}
            </StyledTableCell>
            {row.numbersOfExaminees.map((numExaminees, examineesIndex) => (
              <StyledTableCell
                align='center'
                key={`examinees-${rowIndex}-${examineesIndex}`}
                sx={{
                  backgroundColor: (theme) =>
                    numExaminees.answer === row.answer ? theme.palette.success.light : undefined,
                  minWidth: '90px',
                }}
              >
                {numExaminees.total ?? '-'}
              </StyledTableCell>
            ))}
            {row.percentageOfAnswered.map((percentage, percentageIndex) => (
              <StyledTableCell
                key={`percentage-${rowIndex}-${percentageIndex}`}
                sx={{
                  backgroundColor: (theme) =>
                    percentage.answer === row.answer ? theme.palette.success.light : undefined,
                  minWidth: '90px',
                }}
                align='center'
              >
                {percentage.total?.toFixed(2) ?? '-'}
              </StyledTableCell>
            ))}
            <StyledTableCell
              align='center'
              sx={{
                backgroundColor: (theme) => theme.palette.primary.light,
                p: (theme) => theme.spacing(2, 3),
                minWidth: '100px',
              }}
            >
              {row.pCalculated?.toFixed(2) ?? '-'}
            </StyledTableCell>
          </TableRow>
        );
      })}
    </>
  );
}
